module.exports = __webpack_public_path__ + "assets/ziyuan_3.d919a926.svg";